import { ReactElement, useEffect, useState } from 'react'
import { DashboardCard, Icon } from 'bd-web-components'
import Loader from '../../../components/Loader'
import { TitleChart, CardsRow } from './styles'
import { useGetCurrentMonthNewAdvanceData } from '../../../hooks/new-advanced-analytics-v2'

export function NewAnalyticsCurrentWeb(): ReactElement {
  const [data, setData] = useState<any>(null)

  const {
    currentMonthNewAdvanceWebData,
    currentMonthNewAdvanceWebDataLoading,
    currentMonthNewAdvanceWebDataError,
  } = useGetCurrentMonthNewAdvanceData()

  useEffect(() => {
    if (currentMonthNewAdvanceWebData !== undefined) {
      console.log('current-web', currentMonthNewAdvanceWebData)
      const data = currentMonthNewAdvanceWebData[0]
      setData([
        {
          label: 'Total Antecipado',
          value: data.totalRequested,
          icon: 'checked',
        },
        {
          label: 'Potencial Antecipável',
          value: data.totalSalesWithFees,
          icon: 'creditCard',
        },
        {
          label: 'Taxa média',
          value: data.averageRate,
          icon: 'businessListFormat',
        },
        {
          label: 'Taxa de Conversão',
          value: data.totalConversion,
          icon: 'businessListFormat',
        },
        {
          label: 'Faturamento',
          value: data.totalRevenue,
          icon: 'dashboardTicketIcon',
        },
      ])
    }
  }, [
    currentMonthNewAdvanceWebData,
    currentMonthNewAdvanceWebDataLoading,
    currentMonthNewAdvanceWebDataError,
  ])

  return (
    <>
      {data !== null && (
        <>
          <TitleChart>Indicadores do Mês</TitleChart>
          <br />
          <CardsRow>
            {data.map((indicador: any) => (
              <DashboardCard
                variateCardDescriptionText={indicador.label}
                variateValue={indicador.value}
                isMonetaryValue={false}
              >
                <Icon
                  fill="#333333"
                  classes="question-circle-help-center"
                  iconName={indicador.icon}
                  width={27}
                  height={23}
                />
              </DashboardCard>
            ))}
          </CardsRow>
        </>
      )}

      {currentMonthNewAdvanceWebDataLoading && (
        <>
          <TitleChart>Indicadores do Mês </TitleChart>
          <br />
          <div
            style={{
              height: '150px',
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              border: '1px solid #3333',
              borderRadius: '8px',
            }}
          >
            <Loader />
          </div>
        </>
      )}
      {currentMonthNewAdvanceWebDataError &&
        !currentMonthNewAdvanceWebDataLoading && (
          <>
            <TitleChart>Indicadores do Mês</TitleChart>
            <br />
            <div
              style={{
                height: '150px',
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                border: '1px solid #3333',
                borderRadius: '8px',
              }}
            >
              Um erro aconteceu, tente novamente!
            </div>
          </>
        )}
    </>
  )
}
